import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { environment } from '../../../environments/environment';
import Chart from 'chart.js';

const COMPARISON_OPTIONS = [
  { id: 1, name: '年齢別入会コース' },
  { id: 2, name: '年齢別男女比' },
  { id: 3, name: 'コース別男女比' },
];

const COLOR_PATTERNS = [
  ['#4ebcc4','#D6FF58','#64F9C1','#5BFF7F','#9fffff','#afffff','#bfffff','#cfffff','#dfffff'],
  ['#4ebcc4','#D6FF58','#64F9C1','#5BFF7F','#9fffff','#afffff','#bfffff','#cfffff','#dfffff'],
  ['#4ebcc4','#D6FF58','#64F9C1','#5BFF7F','#9fffff','#afffff','#bfffff','#cfffff','#dfffff'],
  ['#028c47','#4dbd74','#82f0a3','#b5ffd5'],
  ['#ab7a00','#ffc107','#ffff6b','#ffffb9'],
];

const CHART_ELEMENTS = [
  null,
  { title: '年齢別入会コース', elementName: 'ageAndPlanChart' },
  { title: '年齢別男女比', elementName: 'ageAndGenderChart' },
  { title: 'コース別男女比', elementName: 'planAndGenderChart' },
];

function ratioDataInit(planTypeList: any[]): any[] {
  const array: any[] = [];

  let json: any = { total: 0 };
  for (let i = 10; i <= 100; i += 10) json[String(i)] = 0;
  const total1 = { ...JSON.parse(JSON.stringify(json)), name: '合計' };
  const array1: any[] = [total1];
  planTypeList.forEach(v => {
    array1.push({ ...JSON.parse(JSON.stringify(json)), name: v.name });
  });
  array[1] = array1;

  json = { total: 0 };
  for (let i = 10; i <= 100; i += 10) json[String(i)] = 0;
  const total2 = { ...JSON.parse(JSON.stringify(json)), name: '合計' };
  array[2] = [
    total2,
    { ...JSON.parse(JSON.stringify(json)), name: '男性' },
    { ...JSON.parse(JSON.stringify(json)), name: '女性' },
  ];

  json = { total: 0 };
  planTypeList.forEach(v => { json[v.name] = 0; });
  const total3 = { ...JSON.parse(JSON.stringify(json)), name: '合計' };
  array[3] = [
    total3,
    { ...JSON.parse(JSON.stringify(json)), name: '男性' },
    { ...JSON.parse(JSON.stringify(json)), name: '女性' },
  ];

  return array;
}

function getMemberRatioData(data: any[], planTypeList: any[]): any[] {
  const ratioData = ratioDataInit(planTypeList);
  data.forEach(v => {
    ratioData[1][0]['total'] += v.count;
    ratioData[1][0][String(v.ageRange)] += v.count;
    ratioData[1].forEach((r: any) => {
      if (r.name === v.name) {
        r['total'] += v.count;
        r[String(v.ageRange)] += v.count;
      }
    });
    ratioData[2][0]['total'] += v.count;
    ratioData[2][0][String(v.ageRange)] += v.count;
    ratioData[2][v.sex + 1]['total'] += v.count;
    ratioData[2][v.sex + 1][String(v.ageRange)] += v.count;
    ratioData[3][0]['total'] += v.count;
    ratioData[3][0][v.name] += v.count;
    ratioData[3][v.sex + 1]['total'] += v.count;
    ratioData[3][v.sex + 1][v.name] += v.count;
  });
  return ratioData;
}

@Component({
    selector: 'app-aggregation-member-ratio',
    imports: [FormsModule, DecimalPipe],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-list"></i> 一覧</span>
    </div>
    <div class="card-body">
      <form novalidate name="myForm">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">店舗</label>
                <div class="border" style="border-color: #c2cfd6 !important; max-height: 8rem; overflow-y: auto;">
                  <table class="table table-sm mt-1 mb-1">
                    @for (s of studios; track s.id; let i = $index) {
                      <tr>
                        <td class="border-0">
                          <div class="custom-control custom-checkbox custom-control-inline">
                            <input class="custom-control-input" type="checkbox" [id]="'check_' + i" [name]="'check_' + i" [value]="s.id"
                              [checked]="studioChecked[s.id]" (change)="onCheckChange(s.id, $any($event.target).checked, $any($event.target))" [disabled]="searching">
                            <label class="custom-control-label" [for]="'check_' + i">{{ s.name }}</label>
                          </div>
                        </td>
                      </tr>
                    }
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">項目</label>
                <select class="form-control" id="comparison_item" name="comparison_item"
                  [(ngModel)]="selectedComparison" (ngModelChange)="renderCharts()">
                  @for (opt of comparisonOptions; track opt.id) {
                    <option [ngValue]="opt">{{ opt.name }}</option>
                  }
                </select>
              </div>
            </div>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="card-body">
      <div class="form-group row">
        <div class="col-md-12">
          @if (checkLength) {
            <button class="btn btn-success" type="button" (click)="download()" [disabled]="downloading">
              <i class="fa s-icon-dawnload"></i>&nbsp;ダウンロード
            </button>
          }
        </div>
      </div>
      <form name="ratioForm" method="POST" action="/" style="display: none;">
        <input type="text" name="ratio">
        <input type="text" name="selectStudioName">
        <input type="text" name="sheetTitle">
      </form>
      @if (searching) {
        <div class="text-center py-3"><span class="fa fa-spinner fa-spin fa-2x"></span></div>
      }
      @if (checkLength && !searching && allItems.length === 0) {
        <span>該当するデータはありません</span>
      }

      <!-- 年齢別入会コース -->
      @if (allItems.length > 0) {
        <div [class.d-none]="selectedComparison.id !== 1">
          <div class="mb-4 canvas-container" style="height: 400px;">
            <canvas id="ageAndPlanChart"></canvas>
          </div>
          @for (studioRatio of allItems; track st_i; let st_i = $index) {
            <div class="table-responsive">
              <table style="min-width: 1280px;" class="form-group mb-5 table table-sm table-responsive-sm table-borderless table-ptb-0 horizontal-sticky-table">
                <thead>
                  <tr class="table-secondary border-bottom border-light">
                    <td class="pt-0 pb-0" width="10%"><small>{{ studioNames[st_i] }}</small></td>
                    <td class="pt-0 pb-0" width="15%"><small>コース</small></td>
                    <td class="pt-0 pb-0 text-right"><small>10代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>20代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>30代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>40代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>50代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>60代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>70代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>80代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>90代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>100代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>年齢合計</small></td>
                  </tr>
                </thead>
                <tbody>
                  @for (item of studioRatio[1]; track row_i; let row_i = $index) {
                    <tr class="border-bottom border-light">
                      @if (row_i === 0) { <td class="table-primary">会員数</td><td class="table-primary"></td> }
                      @else { <td class="table-white"></td><td class="table-white">{{ item.name }}</td> }
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['10'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['20'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['30'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['40'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['50'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['60'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['70'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['80'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['90'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['100'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item.total | number }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>

        <!-- 年齢別男女比 -->
        <div [class.d-none]="selectedComparison.id !== 2">
          <div class="mb-4 canvas-container" style="height: 400px;">
            <canvas id="ageAndGenderChart"></canvas>
          </div>
          @for (studioRatio of allItems; track st_i; let st_i = $index) {
            <div class="table-responsive">
              <table style="min-width: 1280px;" class="form-group mb-5 table table-sm table-responsive-sm table-borderless table-ptb-0 horizontal-sticky-table">
                <thead>
                  <tr class="table-secondary border-bottom border-light">
                    <td class="pt-0 pb-0" width="10%"><small>{{ studioNames[st_i] }}</small></td>
                    <td class="pt-0 pb-0" width="15%"><small>性別</small></td>
                    <td class="pt-0 pb-0 text-right"><small>10代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>20代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>30代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>40代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>50代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>60代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>70代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>80代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>90代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>100代</small></td>
                    <td class="pt-0 pb-0 text-right"><small>年齢合計</small></td>
                  </tr>
                </thead>
                <tbody>
                  @for (item of studioRatio[2]; track row_i; let row_i = $index) {
                    <tr class="border-bottom border-light">
                      @if (row_i === 0) { <td class="table-primary">会員数</td><td class="table-primary"></td> }
                      @else { <td class="table-white"></td><td class="table-white">{{ item.name }}</td> }
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['10'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['20'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['30'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['40'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['50'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['60'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['70'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['80'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['90'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item['100'] | number }}</td>
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item.total | number }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>

        <!-- コース別男女比 -->
        <div [class.d-none]="selectedComparison.id !== 3">
          <div class="mb-4 canvas-container" style="height: 400px;">
            <canvas id="planAndGenderChart"></canvas>
          </div>
          @for (studioRatio of allItems; track st_i; let st_i = $index) {
            <div class="table-responsive">
              <table class="form-group mb-5 table table-sm table-responsive-sm table-borderless table-ptb-0">
                <thead>
                  <tr class="table-secondary border-bottom border-light">
                    <td class="pt-0 pb-0"><small>{{ studioNames[st_i] }}</small></td>
                    <td class="pt-0 pb-0"><small>性別</small></td>
                    @for (planKey of planKeys; track planKey) {
                      <td class="pt-0 pb-0 text-right"><small>{{ planKey }}</small></td>
                    }
                    <td class="pt-0 pb-0 text-right"><small>コース合計</small></td>
                  </tr>
                </thead>
                <tbody>
                  @for (item of studioRatio[3]; track row_i; let row_i = $index) {
                    <tr class="border-bottom border-light">
                      @if (row_i === 0) { <td class="table-primary">会員数</td><td class="table-primary"></td> }
                      @else { <td class="table-white"></td><td class="table-white">{{ item.name }}</td> }
                      @for (planKey of planKeys; track planKey) {
                        <td class="text-right" [class.table-primary]="row_i === 0">{{ item[planKey] | number }}</td>
                      }
                      <td class="text-right" [class.table-primary]="row_i === 0">{{ item.total | number }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>
  `
})
export class AggregationMemberRatioComponent implements OnInit {
  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);

  studios: any[] = [];
  studioChecked: Record<number, boolean> = {};
  selectedComparison: any = COMPARISON_OPTIONS[0];
  allItems: any[][] = [];
  studioNames: string[] = [];
  planKeys: string[] = [];
  planTypeList: any[] = [];
  searching = false;
  downloading = false;
  private selectedIds: number[] = [];
  private loadedStudioIds: number[] = [];
  private charts: Record<string, any> = {};
  readonly comparisonOptions = COMPARISON_OPTIONS;

  get checkLength(): boolean {
    return Object.values(this.studioChecked).some(v => v);
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('データ集計', 's-icon-marketing');
    [this.studios, this.planTypeList] = await Promise.all([
      this.studioService.list('all') ?? [],
      this.studioService.getPlanType() ?? [],
    ]);
    this.planKeys = (this.planTypeList as any[]).map(v => v.name);
    if (this.studios.length === 1) {
      this.studioChecked = { [this.studios[0].id]: true };
      await this.load();
    }
  }

  onCheckChange(studioId: number, checked: boolean, input?: HTMLInputElement): void {
    const newChecked = { ...this.studioChecked, [studioId]: checked };
    const count = Object.values(newChecked).filter(v => v).length;
    if (count > 3) {
      // Reset the native checkbox too: its bound value was already false.
      if (input) input.checked = false;
      this.studioChecked = {};
      this.load();
      return;
    }
    this.studioChecked = newChecked;
    this.load();
  }

  async load(): Promise<void> {
    this.selectedIds = Object.entries(this.studioChecked)
      .filter(([, v]) => v).map(([k]) => +k)
      .sort((a, b) => a - b);
    if (this.selectedIds.length === 0) {
      this.allItems = [];
      this.studioNames = [];
      this.loadedStudioIds = [];
      this.destroyCharts();
      return;
    }
    this.searching = true;
    this.destroyCharts();
    this.allItems = [];
    this.studioNames = [];
    this.loadedStudioIds = [];
    try {
      for (const id of this.selectedIds) {
        const data: any = await this.studioService.getAggregationMemberRatio(id, 0) ?? [];
        if (!Array.isArray(data) || data.length === 0) continue;
        const rawData: any[] = Array.isArray(data[0]) ? data[0] : (Array.isArray(data) ? data : []);
        this.loadedStudioIds.push(id);
        this.allItems.push(getMemberRatioData(rawData, this.planTypeList));
        const studio = this.studios.find((s: any) => s.id === id);
        this.studioNames.push(studio?.name ?? '');
      }
      setTimeout(() => this.renderCharts(), 0);
    } finally {
      this.searching = false;
    }
  }

  renderCharts(): void {
    if (this.allItems.length === 0) { this.destroyCharts(); return; }
    [1, 2, 3].forEach(sectionIdx => {
        const el = CHART_ELEMENTS[sectionIdx];
        if (!el) return;
        const canvasId = el.elementName;
        if (this.charts[canvasId]) { this.charts[canvasId].destroy(); }
        const ctx = (document.getElementById(canvasId) as HTMLCanvasElement)?.getContext('2d');
        if (!ctx) return;
        ctx.canvas.height = 400;

        const firstSection = this.allItems[0][sectionIdx];
        if (!firstSection) return;
        const labels = Object.keys(firstSection[0]).filter(k => k !== 'total' && k !== 'name');
        const datasets: any[] = [];
        this.allItems.forEach((studioRatio, studioIdx) => {
        studioRatio[sectionIdx].forEach((row: any, idx: number) => {
          if (idx === 0) return;
          const barData = labels.map(key => row[key] ?? 0);
          const colorPalette = COLOR_PATTERNS[studioIdx] ?? COLOR_PATTERNS[0];
          datasets.push({
            yAxisID: `y-axis-${studioIdx}`,
            label: this.studioNames[studioIdx] ? `${this.studioNames[studioIdx]} : ${row.name}` : row.name,
            borderWidth: 1,
            backgroundColor: colorPalette[(idx - 1) % colorPalette.length],
            data: barData,
            stack: studioIdx,
            barPercentage: 0.8,
          });
        });
        });

        this.charts[canvasId] = new Chart(ctx, {
          type: 'bar',
          data: { labels, datasets },
          options: {
            title: { display: true, text: el.title, padding: 3 },
            scales: {
              xAxes: [{ stacked: true }],
              yAxes: [0, 1, 2].map(studioIdx => ({
                id: `y-axis-${studioIdx}`,
                position: 'right',
                display: studioIdx === 0,
                stacked: true,
                ticks: {
                  max: 500,
                  min: 0,
                  callback: (label: any) => label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '人',
                },
              })).concat([{
                // 旧版 aggregation.js:512-525 の左側の割合軸（0.00%〜30.00%）
                id: 'y-l-axis-0',
                type: 'linear',
                position: 'left',
                ticks: {
                  max: 30.00,
                  min: 0.00,
                  stepSize: 1.00,
                  callback: (label: any) => label.toString() + '.00%',
                },
                gridLines: { drawOnChartArea: false },
              }] as any),
            },
            legend: { labels: { boxWidth: 30, padding: 20 }, display: true },
            tooltips: { mode: 'label' },
            responsive: true,
            maintainAspectRatio: false,
          },
        } as any);
    });
  }

  private destroyCharts(): void {
    Object.values(this.charts).forEach(c => { if (c) c.destroy(); });
    this.charts = {};
  }

  async download(): Promise<void> {
    if (this.downloading || this.allItems.length === 0) return;
    this.downloading = true;
    try {
      const selectedStudios = this.studios
        .filter((s: any) => this.loadedStudioIds.includes(s.id))
        .sort((a: any, b: any) => a.id - b.id);
      const form = document.forms.namedItem('ratioForm') as HTMLFormElement | null;
      if (!form) return;
      form.method = 'POST';
      form.action = `${environment.apiBaseUrl}/aggregation/excel/ratio`;
      (form.elements.namedItem('ratio') as HTMLInputElement).value = JSON.stringify(this.allItems);
      (form.elements.namedItem('selectStudioName') as HTMLInputElement).value = JSON.stringify(selectedStudios);
      (form.elements.namedItem('sheetTitle') as HTMLInputElement).value = JSON.stringify(COMPARISON_OPTIONS);
      form.submit();
    } finally {
      setTimeout(() => { this.downloading = false; }, 5000);
    }
  }
}
